html[data-portal-preview-theme='dark'],
html[data-portal-preview-theme='dark'] body,
html[data-portal-preview-theme='dark'] #ghost-portal-root {
    background: #1d1d1d;
}
